import { render } from "./DefaultButton.vue?vue&type=template&id=1e670d80&ts=true"
import script from "./DefaultButton.vue?vue&type=script&lang=ts"
export * from "./DefaultButton.vue?vue&type=script&lang=ts"

import "./DefaultButton.vue?vue&type=style&index=0&id=1e670d80&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__